export const REPORTS = 'reports'
export const REPORTS_PERFORMANCE = 'reports-performance'
